import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent,
  DialogTitle, Grid, Link, TextField, Typography,
} from '@mui/material';

interface Props {
  open: boolean;
  connector: any;
  inputs: Record<string, any>;
  setInputs: (inputs: Record<string, any>) => void;
  isLoading: boolean;
  error: string | null;
  setError: (e: string | null) => void;
  isExisting: boolean;
  onClose: () => void;
  onAuthorize: () => void;
}

const ConnectorSetupModal = ({
  open, connector, inputs, setInputs,
  isLoading, error, setError, isExisting, onClose, onAuthorize,
}: Props) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    {connector && (
      <>
        <DialogTitle sx={{ fontWeight: 700, fontSize: '1.125rem', pb: 0.5 }}>
          {isExisting ? `Manage ${connector.name}` : `Connect ${connector.name}`}
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 400, mt: 0.25 }}>
            {isExisting ? 'Update your credentials below.' : 'Enter your credentials to connect.'}
          </Typography>
        </DialogTitle>
        <DialogContent>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>
          )}
          <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: '12px', p: 2, mt: 1 }}>
            <Typography variant="subtitle2" gutterBottom>Configuration</Typography>
            <Grid container spacing={2}>
              {connector.fields.map((field: any) => (
                <Grid item xs={12} key={field.name}>
                  <TextField
                    label={field.label} type={field.type} fullWidth
                    value={inputs[field.name] || ''}
                    onChange={(e) => setInputs({ ...inputs, [field.name]: e.target.value })}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button variant="outlined" onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={onAuthorize} disabled={isLoading}>
            {isLoading ? 'Saving…' : isExisting ? 'Save changes' : 'Connect'}
          </Button>
        </DialogActions>
      </>
    )}
  </Dialog>
);

export default ConnectorSetupModal;
